export const getIntialValues = (data = {}) => {
  return {
    meta_seo: {
      meta_title: data?.meta_seo?.meta_title || "",
      meta_keyword: data?.meta_seo?.meta_keyword || "",
      meta_desc: data?.meta_seo?.meta_desc || "",
    },

    header: {
      heading: data?.header?.heading || "",
      secondry_heading: data?.header?.secondry_heading || "",
      description: data?.header?.description || "",
    },
    section_empower: {
      educators: data?.section_empower?.educators?.length
        ? data.section_empower.educators
        : [
            {
              title: "",
              video_url: "",
              image_link: "",
              alt_tag:"",
            },
          ],
    },
  };
};

export const generatePayload = (values) => {
  return {
    meta_seo: {
      meta_title: values?.meta_seo?.meta_title || "",
      meta_keyword: values?.meta_seo?.meta_keyword || "",
      meta_desc: values?.meta_seo?.meta_desc || "",
    },
    header: {
      heading: values?.header?.heading || "",
      secondry_heading: values?.header?.secondry_heading || "",
      description: values?.header?.description || "",
    },
    section_empower: {
      educators: values?.section_empower?.educators?.length
        ? values.section_empower.educators
        : [
            {
              title: "",
              video_url: "",
              image_link: "",
              alt_tag:"",
            },
          ],
    },
  };
};
